module.exports = __webpack_public_path__ + "img/c06_unittechsapperchampion_Normal_ua.6d3440e0.webp";